import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import Empty from "src/components/utils/Empty";

const useStyles = makeStyles((theme) => ({
  headerText: {
    color: theme.palette.text.hint,
  },
  tableCell: {
    background: theme.palette.background.paper,
    "&:hover": { background: theme.palette.background.paper },
    cursor: "default",
  },
}));

export default function BaseAddPoolTable({ tableHeaderConfig, isEmpty, children }) {
  const cls = useStyles();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <>
      <TableContainer>
        <Table style={{ minWidth: isMobile && 700 }}>
          <TableHead>
            <TableRow style={{ background: "transparent" }}>
              {tableHeaderConfig.map((item, index) => {
                if (index == 0)
                  return (
                    <TableCell key={index} style={{ position: "sticky", left: 0 }} className={cls.tableCell}>
                      <Typography className={cls.headerText}>{item.text}</Typography>
                    </TableCell>
                  );
                else
                  return (
                    <TableCell key={index}>
                      <Typography className={cls.headerText}>{item.text}</Typography>
                    </TableCell>
                  );
              })}
            </TableRow>
          </TableHead>
          <TableBody>{children}</TableBody>
        </Table>
      </TableContainer>
      {isEmpty && (
        <Box display="flex" justifyContent="center" width="100%">
          <Empty title="No Data" iconProps={{ style: { fontSize: "60px" } }} />
        </Box>
      )}
    </>
  );
}
